<template>
  <div>
    <!-- <div>
      <span>Input Settings</span>
      <svg
        style="float: inline-end"
        @click="$bvModal.hide('inputSettings')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div> -->
    <div class="d-flex align-items-center justify-content-end modal-title-head">
      <div class="title-head">
        <p class="feedback-title-head">{{ $t('journeyBuilder.flow.inputSettings_title')}}</p>
      </div>
      <svg
        @click="$bvModal.hide('inputSettings')"
        class="CloseFeedbackSettings"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>
    <div class="gps-location">
      <b-form-group
        label-cols-sm="12"
        label-cols-lg="12"
        id="loginMode"
        :label="$t('journeyBuilder.flow.inputSettings_getGps')"
        label-for="loginMode"
        class="label-positionLogin"
      >
        <b-form-group
          style="margin-bottom: 0px"
          class="custom-activeRadio"
          v-slot="{ ariaDescribedby }"
        >
          <b-form-radio-group stacked v-model="$v.geoSetting.value.$model">
            <b-form-radio
              v-for="(option, index) in options"
              :key="index"
              class="first-radiocheck"
              style="margin-bottom: 32px"
              :value="option.value"
            >
              {{ option.text }}
              <p v-if="option.value == 'optional'" class="mandatory">
               {{ $t('journeyBuilder.flow.inputSettings_allowGpsChoice') }}
              </p>
              <p v-else-if="option.value == 'mandatory'" class="mandatory">
                {{ $t('journeyBuilder.flow.inputSettings_forceGps') }}
              </p>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-form-group>
    </div>
    <div class="d-flex justify-content-end vp-pt-8 submit-con">
      <button
        class="btn btn-primary save-feedback"
        :disabled="$v.geoSetting.value.$invalid || !$v.geoSetting.$dirty"
        @click="submit"
      >
        {{ $t("common.save").toUpperCase() }}
      </button>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      geoSetting: {},
      options: [
        {
          text: this.$t('signInOut.massAction.status.notRequired'),
          value: "not_required",
        },
        {
          text: this.$t('common.optional'),
          value: "optional",
        },
        { text: this.$t('common.mandatory'), value: "mandatory" },
      ],
    };
  },
  validations: {
    geoSetting: {
      value: {
        required,
      },
    },
  },
  beforeMount() {
    this.geoSetting = cloneDeep(this.settings);
    if (!this.geoSetting.value) this.geoSetting.value = "not_required";
  },
  methods: {
    submit() {
      this.$emit("updateInputGeo", this.geoSetting);
      this.$bvModal.hide("inputSettings");
    },
  },
};
</script>

<style lang="scss">
div#inputSettings___BV_modal_content_ {
  width: 492px !important;
  border-radius: 26px !important;
  div#inputSettings___BV_modal_body_ {
    padding: 40px 38px !important;
    .d-flex.align-items-center.justify-content-end.modal-title-head {
      margin-bottom: 40px;
      margin-inline-end: auto;
      width: 416px;
      margin-inline-start: auto;
    }
    p.feedback-title-head {
      font-size: 17px;

      font-weight: 700;
      line-height: 20.4px;
      color: #000;
      margin-bottom: 0 !important;
      margin-inline-end: 140px;
    }
    .CloseFeedbackSettings {
      margin-inline-end: -3px;
      margin-top: -5px;
    }
    .submit-con {
      width: 416px;
      margin-inline-end: auto;
      margin-inline-start: auto;
    }
    button.btn.btn-primary.save-feedback {
      width: 416px !important;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;

      font-weight: 700;
      line-height: 17px;
    }
    button.btn.btn-primary.save-feedback:disabled {
      opacity: 0.4 !important;
      cursor: not-allowed;
    }

    button.btn.btn-primary.save-feedback:hover {
      background-color: #103f5e !important;
    }
    .gps-location {
      width: 416px;
      p.mandatory {
        margin-inline-start: -40px;
        margin-top: 16px;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        color: #787878;
      }
      div#loginMode {
        margin-bottom: 0px !important;
        width: 416px !important;
      }
      .custom-control.custom-control-inline.custom-radio {
        display: block !important;
        margin-bottom: 32px !important;
      }
      label.custom-control-label {
        font-weight: 600;
        color: #787878;
        padding-inline-start: 16px;
        padding-top: 5px;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.25px;
      }
      .custom-activeRadio
        .custom-radio
        .custom-control-input:checked
        ~ .custom-control-label {
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.25px;
        color: #103f5e;
      }

      label#loginMode__BV_label_ {
        font-weight: 600;
        font-size: 16px;
        line-height: 17px;
        margin-bottom: 32px;
        letter-spacing: 0.25px;
        color: #787878 !important;
      }
    }
  }
}
</style>
